import { Mesh } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import model from "../../../../../assets/models/GLB_Oxxo_V4.glb";
import gsap from "gsap";
import { GUI } from "dat.gui";

export class MapOxxoTopicTwo extends Mesh {
	constructor(loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.scale.set(2, 2, 2);
		// this.rotation.y = MathUtils.degToRad(90)
	}

	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);

			this.Aguas_1001 = gltf.scene.getObjectByName("Aguas_1001", true);
			this.Aguas_10 = gltf.scene.getObjectByName("Aguas_10", true);
			this.Aguas_13 = gltf.scene.getObjectByName("Aguas_13", true);
			this.Aguas_12 = gltf.scene.getObjectByName("Aguas_12", true);
			this.Aguas_11 = gltf.scene.getObjectByName("Aguas_11", true);
			this.Aguas_14 = gltf.scene.getObjectByName("Aguas_14", true);
			this.Aguas_15 = gltf.scene.getObjectByName("Aguas_15", true);
			this.Gondola002 = gltf.scene.getObjectByName("Gondola002", true);
			// const newMaterialGondoa= this.Piso.material.clone();

			this.cafe_1 = gltf.scene.getObjectByName("cafe_1", true);
			this.cafe_2 = gltf.scene.getObjectByName("cafe_2", true);
			this.cafe_3 = gltf.scene.getObjectByName("cafe_3", true);

			this.Detergente_ = gltf.scene.getObjectByName("Detergente_", true);
			this.Harina_ = gltf.scene.getObjectByName("Harina_", true);
			this.Harina_3 = gltf.scene.getObjectByName("Harina_3", true);

			const newMaterialDetergente = this.Detergente_.material.clone();
			this.Detergente_.material = newMaterialDetergente

			const newMaterialHarina_ = this.Harina_.material.clone();
			this.Harina_.material = newMaterialHarina_

			const newMaterialHarina_1 = this.Harina_3.material.clone();
			this.Harina_3.material = newMaterialHarina_1

			this.Gondola001 = gltf.scene.getObjectByName("Gondola001", true);

			// iluminacion
			this.Mostrador001 = gltf.scene.getObjectByName("Mostrador001", true);
			this.Piso = gltf.scene.getObjectByName("Piso", true);
			this.Techo = gltf.scene.getObjectByName("Techo", true);
			this.Paredes = gltf.scene.getObjectByName("Paredes", true);
			this.Refri_coca_1 = gltf.scene.getObjectByName("Refri_coca_1", true);
			this.Estructura001 = gltf.scene.getObjectByName("Estructura001", true);
			this.Yelox = gltf.scene.getObjectByName("Yelox", true);
			this.Helado = gltf.scene.getObjectByName("Helado", true);

			const newMaterialPiso = this.Piso.material.clone();
			newMaterialPiso.color.set(0xd6d6d6);
			newMaterialPiso.emissiveIntensity = 2;
			newMaterialPiso.emissive.set("#2E2E2E");
			this.Piso.material = newMaterialPiso;
			const newMaterialTecho = this.Techo.material.clone();
			newMaterialTecho.color.set(0xffffff);
			newMaterialTecho.emissiveIntensity = 2;
			newMaterialTecho.emissive.set("#595959");
			this.Techo.material = newMaterialTecho;
			const newMaterialHelado = this.Helado.material.clone();
			newMaterialHelado.color.set(0xd1d1d1);
			newMaterialHelado.emissiveIntensity = 3.6;
			newMaterialHelado.emissive.set("#5E5E5E");
			this.Helado.material = newMaterialHelado;

			this.Paredes.material.emissiveIntensity = 2;
			this.Refri_coca_1.material.emissiveIntensity = 0.98;
			this.Yelox.material.emissiveIntensity = 2.58;
			this.Estructura001.material.emissive.set("#595959");
			this.Estructura001.material.emissiveIntensity = 1;
			this.Mostrador001.material.emissive.set("#737373");
			this.Mostrador001.material.emissiveIntensity = 2;


			this.positionAllObject = {
				Detergente_: this.Detergente_.position.clone(),
				Harina_: this.Harina_.position.clone(),
				Harina_3: this.Harina_3.position.clone(),
			}
		});
	}

	onPositionInit() {
		Object.entries(this.positionAllObject).forEach(([key, value]) => {
			this[key].position.copy(value);
		})
	}

	onAnimationOpacity(object, callback = () => { }) {
		const newMaterial = object.material.clone();
		object.material = newMaterial;
		object.material.transparent = true
		gsap.to(object.material, {
			opacity: 0,
			duration: 2,
			onComplete: () => {
				callback()
			},
		});
	}

	clearAnimation() {
		if (this.multiAnimationEmissive) {
			this.multiAnimationEmissive.kill()
			this.multiAnimationEmissive = null
		}

		this.Detergente_.material.emissiveIntensity = 0
		this.Harina_.material.emissiveIntensity = 0
		this.Harina_3.material.emissiveIntensity = 0

	}

	onAnimateEmissiveMultiIntensity(object = []) {
		this.clearAnimation()

		if (object.length === 0) {
			return
		}

		const materialObject = object.map((obj) => {
			return obj.material
		})

		this.multiAnimationEmissive = gsap.to(materialObject, {
			emissiveIntensity: 25,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
	}

	helpers(object = null, limit = 20) {
		if (!object) {
			return
		}
		const gui = new GUI();
		const premiaFolder = gui.addFolder(object.name);
		premiaFolder.add(object.position, "x", -limit, limit).step(0.0001).name("Posición X");
		premiaFolder.add(object.position, "y", -limit, limit).step(0.0001).name("Posición Y");
		premiaFolder.add(object.position, "z", -limit, limit).step(0.0001).name("Posición Z");
		premiaFolder.add(object.rotation, "x", -5, 5).step(0.0001).name("Rotacion X");
		premiaFolder.add(object.rotation, "y", -5, 5).step(0.0001).name("Rotacion Y");
		premiaFolder.add(object.rotation, "z", -5, 5).step(0.0001).name("Rotacion Z");
		premiaFolder.add(object.scale, "x", 0, 5).step(0.01).name("Escala X");
		premiaFolder.add(object.scale, "y", 0, 5).step(0.01).name("Escala Y");
		premiaFolder.add(object.scale, "z", 0, 5).step(0.01).name("Escala Z");
	}

	renderAnimations() { }
}
